;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout = APP.module('Layout');

	Layout.LoginFormLeft = Marionette.LayoutView.extend({
		template: JST.LoginFormLeftLayout,
		regions: {
			aside: "aside",
			main:  "main"
		}
	});

}(window, APP, Backbone, Marionette, $, _));
